<template>
    <div class="cms-container mb-4">
        <ToastCMS ref="toast" />
        <!-- PREVIEW IMAGE -->
        <div v-if="showPreviewModal" class="preview-modal w-100 h-100 d-flex align-items-center justify-content-center"
            @click.self="closePreviewImage">
            <div class="d-block-align-items-center justify-content-center w-100 mx-3">
                <div class="modal-content bg-transparent position-relative border-0">
                    <button class="close-btn position-fixed text-white bg-transparent border-0"
                        @click="closePreviewImage">&times;</button>

                    <div class="d-flex justify-content-between align-items-center border-0">
                        <button v-if="previewImages.length > 1" @click="prevImage" :disabled="currentPreviewIndex === 0"
                            class="material-symbols-outlined bg-transparent border-0 text-white">
                            arrow_back_ios
                        </button>

                        <video v-if="previewIsVideo" :src="previewImages[currentPreviewIndex]" controls muted
                            style="max-width:70vw; max-height:70vh; display:block; margin:0 auto;"></video>
                        <img v-else :src="previewImages[currentPreviewIndex]" alt="Preview Image">

                        <button v-if="previewImages.length > 1" @click="nextImage"
                            :disabled="currentPreviewIndex === previewImages.length - 1"
                            class="material-symbols-outlined bg-transparent border-0 text-white">
                            arrow_forward_ios
                        </button>
                    </div>
                </div>

                <div v-if="previewImages.length > 1" class="text-center mt-3">
                    <span class="text-white">Image {{ currentPreviewIndex + 1 }} of {{ previewImages.length }}</span>
                </div>
            </div>
        </div>

        <div class="sticky-controls">
            <div class="main-header d-flex align-items-center justify-content-between px-3">
                <div class="csr-header text-dark">CSR Activities</div>
                <button type="button" @click="addContainer"
                    class="vmc-bg-prime-4 border-0 text-white rounded px-2 py-1">
                    Add Item
                </button>
            </div>
        </div>
        <!-- BACKGROUND MEDIA — separate from item list -->
        <div class="px-3">
            <div class="mt-3">
                <div class="d-flex align-items-center justify-content-between w-100 my-2">
                    <div class="d-flex align-items-center justify-content-between w-100 mt-2">
                        <span class="item-number text-dark">
                            Background Media (MP4 or Image, Max 10MB)
                        </span>
                        <div class="d-flex align-items-center" style="gap:5px;">
                            <button type="button" @click="previewBgMedia"
                                class="vmc-bg-prime-4 text-white rounded px-3 py-1 border-0">
                                View
                            </button>
                        </div>
                    </div>
                </div>
                <div
                    style="height:200px; width:100%; background-position:center; border:1px solid gray; margin-bottom:10px; display:flex; justify-content:center; align-items:center; overflow:hidden;">

                    <video v-if="csrBackgroundVideo" :src="csrBackgroundVideo" class="w-100 h-100" controls muted
                        style="object-fit:contain;"></video>
                    <img v-else-if="csrBackgroundImage" :src="csrBackgroundImage" class="w-100 h-100"
                        style="object-fit:contain;">

                    <template v-else>
                        <input type="file" id="upload-csr-bg" accept="video/mp4, image/png, image/jpeg, image/jpg"
                            hidden @change="onBgMediaChange($event)">
                        <label for="upload-csr-bg"
                            class="w-100 h-100 d-flex flex-column justify-content-center align-items-center text-center"
                            style="cursor:pointer;">
                            <i class="material-symbols-outlined">upload</i>
                            <span>Upload Background (MP4 or Image)</span>
                        </label>
                    </template>
                </div>
                <button @click="removeBgMedia" type="button"
                    class="w-100 vmc-bg-prime-6 py-1 text-white mt-1 border-0 rounded">
                    Remove Media
                </button>
            </div>
        </div>
        <form action="" id="csr" @submit.prevent="saveAllChanges">
            <div class="pb-3">
                <div class="grid-header">
                    <div class="w-100 mt-4" v-for="(container, index) in containers" :key="index">
                        <div class="d-flex px-3 align-items-center justify-content-between w-100 mt-2">
                            <span class="item-number text-dark">
                                Item # {{ index + 1 }}
                            </span>
                            <button type="button" @click="removeContainer(index)"
                                class="px-2 py-1 vmc-bg-prime-6 border-0 text-white rounded">
                                Remove
                            </button>
                        </div>
                        <div class="input-group mt-3 px-3">
                            <input type="text" class="input-field w-100 text-dark p-2" placeholder=""
                                v-model="container.title">
                            <label class="floating-label mx-3">CSR Programs</label>
                        </div>
                        <div class="d-flex mt-3 px-3" style="gap:10px;">
                            <div class="w-100">
                                <label class="text-dark">Year:</label>
                                <input type="text" class="w-100 text-dark p-1" placeholder="Year"
                                    v-model="container.year">
                            </div>
                            <div class="w-100">
                                <label class="text-dark">Type of Activities:</label>
                                <select class="w-100 text-dark" v-model="container.type">
                                    <option value="" disabled class="text-dark">--- Choose one ---</option>
                                    <option value="Outside Veritas Activities" class="text-dark">Outside Veritas
                                        Activities
                                    </option>
                                    <option value="Veritas Activities" class="text-dark">Veritas Activities</option>
                                </select>
                            </div>
                        </div>
                        <div class="mt-3 px-3">
                            <input type="file" multiple :id="'upload-csr-img-' + index"
                                accept="image/png, image/jpeg, image/jpg" hidden @change="onImageChange($event, index)">

                            <div class="d-flex justify-content-between align-items-center mb-2">
                                <span class="text-dark">Image</span>
                                <button type="button" @click="previewImage(index)"
                                    class="vmc-bg-prime-4 text-white rounded px-3 py-1 border-0">
                                    View
                                </button>
                            </div>
                            <div class="img-placeholder w-100 mb-2" style="border:1px solid gray;">
                                <div v-if="container.images && container.images.length"
                                    class="d-flex flex-wrap h-100 align-items-center justify-content-center"
                                    style="gap:10px;">
                                    <div v-for="(img, i) in container.images.slice(0, 4)" :key="i"
                                        style="position:relative;">
                                        <img class="img-container" :src="img">
                                        <button type="button" @click="deleteSingleImage(index, i)"
                                            class="d-flex align-items-center justify-content-center position-absolute bg-danger border-0 rounded-circle"
                                            style="top:-6px; right:-6px; width:20px; height:20px; cursor:pointer;">
                                            <span class="material-symbols-outlined text-white"
                                                style="font-size:12px;">remove</span>
                                        </button>
                                    </div>
                                    <div @click="previewImage(index)"
                                        v-if="container.images && container.images.length > 4"
                                        class="more-image d-flex align-items-center justify-content-center bg-secondary text-white border border-gray rounded">
                                        +{{ container.images.length - 4 }} more
                                    </div>
                                </div>

                                <div v-else
                                    class="w-100 h-100 d-flex flex-column justify-content-center align-items-center"
                                    style="cursor:pointer;" @click="openFileInput(index)">
                                    <i class="material-symbols-outlined">upload</i>
                                    <span>Upload Photo</span>
                                </div>
                            </div>
                            <div class="d-flex" style="gap:10px">
                                <button type="button" @click="openFileInput(index)"
                                    class="vmc-bg-prime-4 w-100 text-white rounded px-2 py-1 border-0">
                                    Add Photo
                                </button>
                                <button type="button" @click="resetImage(index)"
                                    class="vmc-bg-prime-6 w-100 text-white rounded px-2 py-1 border-0">
                                    Remove All Photo
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </form>
        <div class="px-3 mt-4">
            <button type="submit" form="csr" class="vmc-bg-prime-4 text-white border-0 rounded px-3 py-1">
                Save All Changes
            </button>
        </div>
    </div>
</template>

<script>
import ToastCMS from '../ToastCMS.vue';
export default {
    name: "CSRActivitiesCMS",
    components: {
        ToastCMS
    },
    data() {
        return {
            /*
             * Flat shape for the UI: { year, type, title, images[] }
             * Backend shape: csrYears: [{ year, type, activities: [{ title, images[] }] }]
             * We flatten on load and re-nest on save.
             */
            containers: [],
            originalContainers: [],
            csrBackgroundVideo: '',
            csrBackgroundImage: '',
            originalCsrBgVideo: '',
            originalCsrBgImage: '',
            previewImages: [],
            previewIsVideo: false,
            showPreviewModal: false,
            currentPreviewIndex: 0
        }
    },
    methods: {
        addContainer() {
            this.containers.push({
                year: '',
                type: '',
                title: '',
                images: []
            });
            this.$refs.toast.showToast(`Item # ${this.containers.length} added`, "success");
        },

        removeContainer(index) {
            this.containers.splice(index, 1);
            this.$refs.toast.showToast(`Item # ${index + 1} removed`, "error");
        },

        async onImageChange(e, index) {
    const files = e.target.files;
    if (!files || !files.length) return;

    if (!this.containers[index].images) {
        this.$set(this.containers[index], 'images', []);
    }

    for (const file of Array.from(files)) {
        if (file.type.startsWith("image/")) {
            const formData = new FormData();
            formData.append('image', file);

            try {
                const response = await fetch('/vmc/api/upload', {
                    method: 'POST',
                    headers: {
                        'Authorization': `Bearer ${localStorage.getItem('vmc_token')}`
                    },
                    body: formData
                });

                const data = await response.json();

                if (response.ok) {
                    this.containers[index].images.push(data.url);
                    this.$refs.toast.showToast(`Image(s) attached`, "success");
                } else {
                    console.error("Upload failed:", data.message);
                }
            } catch (error) {
                console.error("Upload error:", error);
            }
        }
    }
    e.target.value = "";
},

        openFileInput(index) {
            document.getElementById(`upload-csr-img-${index}`).click();
        },

        previewImage(index) {
            if (!this.containers[index].images || !this.containers[index].images.length) {
                this.$refs.toast.showToast("No images to view", "warning");
                return;
            }
            this.previewImages = [...this.containers[index].images];
            this.currentPreviewIndex = 0;
            this.showPreviewModal = true;
        },

        closePreviewImage() {
            this.showPreviewModal = false;
            this.previewImages = [];
            this.previewIsVideo = false;
        },

        prevImage() {
            if (this.currentPreviewIndex > 0) this.currentPreviewIndex--;
        },

        nextImage() {
            if (this.currentPreviewIndex < this.previewImages.length - 1) this.currentPreviewIndex++;
        },

        resetImage(index) {
            const hasImages = this.containers[index].images && this.containers[index].images.length > 0;
            if (hasImages) {
                this.$refs.toast.showToast(`All images removed`, "error");
            } else {
                this.$refs.toast.showToast(`No image attached`, "warning");
            }
            this.$set(this.containers[index], 'images', []);
            const input = document.getElementById(`upload-csr-img-${index}`);
            if (input) input.value = "";
        },

        deleteSingleImage(index, i) {
            this.containers[index].images.splice(i, 1);
            this.$refs.toast.showToast("Image removed", "error");
        },

        async onBgMediaChange(e) {
    const file = e.target.files[0];
    if (!file) return;

    if (file.size > 10 * 1024 * 1024) {
        this.$refs.toast.showToast("File is too large! Max 10MB.", "error");
        e.target.value = "";
        return;
    }

    const formData = new FormData();
    formData.append('image', file);

    try {
        const response = await fetch('/vmc/api/upload', {
            method: 'POST',
            headers: {
                'Authorization': `Bearer ${localStorage.getItem('vmc_token')}`
            },
            body: formData
        });

        const data = await response.json();

        if (response.ok) {
            if (file.type.startsWith('video/')) {
                this.csrBackgroundVideo = data.url;
                this.csrBackgroundImage = '';
            } else {
                this.csrBackgroundImage = data.url;
                this.csrBackgroundVideo = '';
            }
            this.$refs.toast.showToast("Background media attached", "success");
        } else {
            console.error("Upload failed:", data.message);
        }
    } catch (error) {
        console.error("Upload error:", error);
    }

    e.target.value = "";
},

        previewBgMedia() {
            if (!this.csrBackgroundVideo && !this.csrBackgroundImage) {
                this.$refs.toast.showToast("No background media to view", "warning");
                return;
            }
            if (this.csrBackgroundVideo) {
                this.previewImages = [this.csrBackgroundVideo];
                this.previewIsVideo = true;
            } else {
                this.previewImages = [this.csrBackgroundImage];
                this.previewIsVideo = false;
            }
            this.currentPreviewIndex = 0;
            this.showPreviewModal = true;
        },

        removeBgMedia() {
            if (!this.csrBackgroundVideo && !this.csrBackgroundImage) {
                this.$refs.toast.showToast("No background media to remove", "warning");
                return;
            }
            this.csrBackgroundVideo = '';
            this.csrBackgroundImage = '';
            this.$refs.toast.showToast("Background media removed", "error");
        },

        onKeyboard(e) {
            if (this.showPreviewModal) {
                switch (e.key) {
                    case 'ArrowRight': this.nextImage(); break;
                    case 'ArrowLeft': this.prevImage(); break;
                    case 'Escape': this.showPreviewModal = false; break;
                }
            }
        },

        /* Flatten backend nested structure → flat UI containers */
        flattenCsrYears(csrYears) {
            const flat = [];
            csrYears.forEach(yearGroup => {
                if (Array.isArray(yearGroup.activities) && yearGroup.activities.length) {
                    yearGroup.activities.forEach(activity => {
                        flat.push({
                            year: yearGroup.year ?? '',
                            type: yearGroup.type ?? '',
                            title: activity.title ?? '',
                            images: Array.isArray(activity.images) ? [...activity.images] : []
                        });
                    });
                } else {
                    /* Year group with no activities — still keep the year/type */
                    flat.push({
                        year: yearGroup.year ?? '',
                        type: yearGroup.type ?? '',
                        title: '',
                        images: []
                    });
                }
            });
            return flat;
        },

        /* Re-nest flat UI containers → backend csrYears shape */
        nestContainers(containers) {
            const map = new Map();
            containers.forEach(c => {
                const key = `${c.year}__${c.type}`;
                if (!map.has(key)) {
                    map.set(key, { year: c.year, type: c.type, activities: [] });
                }
                map.get(key).activities.push({ title: c.title, images: c.images || [] });
            });
            return Array.from(map.values());
        },

        async loadFormData() {
            try {
                const token = localStorage.getItem('vmc_token');
                const response = await fetch(`${process.env.VUE_APP_API_URL}/api/content?_nocache=${new Date().getTime()}`, {
                    headers: { 'Authorization': `Bearer ${token}` }
                });

                if (!response.ok) throw new Error("Failed to fetch content");

                const data = await response.json();

                if (data && Object.keys(data).length > 0) {
                    if (Array.isArray(data.csrYears)) {
                        this.containers = this.flattenCsrYears(data.csrYears);
                    }
                    this.csrBackgroundVideo = data.csrBackgroundVideo ?? '';
                    this.csrBackgroundImage = data.csrBackgroundImage ?? '';
                }

                this.originalContainers = JSON.parse(JSON.stringify(this.containers));
                this.originalCsrBgVideo = this.csrBackgroundVideo;
                this.originalCsrBgImage = this.csrBackgroundImage;

            } catch (error) {
                console.error("Load error:", error);
                this.$refs.toast.showToast("Failed to load data!", "error");
            }
        },

        async saveAllChanges(e) {
            e.preventDefault();

            if (!this.hasChanges) {
                this.$refs.toast.showToast("Nothing to save.", "warning");
                return;
            }

            try {
                const token = localStorage.getItem('vmc_token');
                const response = await fetch(`${process.env.VUE_APP_API_URL}/api/update`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${token}`
                    },
                    body: JSON.stringify({
                        csrYears: this.nestContainers(this.containers),
                        csrBackgroundVideo: this.csrBackgroundVideo,
                        csrBackgroundImage: this.csrBackgroundImage
                    })
                });

                if (!response.ok) throw new Error("Server error");

                this.originalContainers = JSON.parse(JSON.stringify(this.containers));
                this.originalCsrBgVideo = this.csrBackgroundVideo;
                this.originalCsrBgImage = this.csrBackgroundImage;

                this.$refs.toast.showToast("Saved all changes.", "success");
                setTimeout(() => { window.location.reload(); }, 1500);

            } catch (error) {
                console.error("Save error:", error);
                this.$refs.toast.showToast("Save failed. Check your connection.", "error");
            }
        }
    },

    async mounted() {
        window.addEventListener('keydown', this.onKeyboard);
        await this.loadFormData();
    },

    beforeDestroy() {
        window.removeEventListener('keydown', this.onKeyboard);
    },

    computed: {
        hasChanges() {
            return (
                JSON.stringify(this.containers) !== JSON.stringify(this.originalContainers) ||
                this.csrBackgroundVideo !== this.originalCsrBgVideo ||
                this.csrBackgroundImage !== this.originalCsrBgImage
            );
        }
    }
}
</script>

<style scoped>
.toast-container {
    position: fixed;
    width: 300px;
    top: 20px;
    right: 20px;
    z-index: 9999;
}

hr {
    border-top: 1px solid black;
}

.sticky-controls {
    position: sticky;
    z-index: 1;
    background-color: white;
}

@media (min-width: 330px) {
    .main-header {
        padding: 15px 0;
        border-top: 1px solid #ccc;
        border-bottom: 1px solid #ccc;
    }

    .csr-header {
        font-size: 17px;
        font-weight: 600;
    }

    .item-number {
        font-size: 18px;
        font-weight: 600;
    }

    button {
        font-size: 16px;
    }

    input,
    select {
        font-size: 15px;
        outline: none;
        height: 36px;
    }

    .input-group {
        position: relative;
        display: flex;
    }

    .input-field {
        border: 1px solid gray;
        border-radius: 4px !important;
        width: 100%;
        outline: none;
    }

    .floating-label {
        position: absolute;
        top: 50%;
        left: 8px;
        transform: translateY(-50%);
        color: gray;
        background-color: white;
        transition: all 0.3s ease;
        pointer-events: none;
    }

    .input-field:focus~.floating-label,
    .input-field:not(:placeholder-shown)~.floating-label {
        top: 0;
        left: 8px;
        transform: translateY(-50%);
        font-size: 12px;
    }

    .img-container {
        height: 50px;
        width: 50px;
        object-fit: cover;
        border: 1px solid #ccc;
    }

    .img-placeholder {
        height: 100px;
        background-position: center;
    }

    .more-image {
        height: 50px;
        width: 50px;
        font-size: 14px;
        text-align: center;
        object-fit: cover;
        cursor: pointer;
    }

    .grid-header>div {
        width: 100%;
    }

    input::-webkit-outer-spin-button,
    input::-webkit-inner-spin-button {
        -webkit-appearance: none;
        margin: 0;
    }

    .preview-modal {
        position: fixed;
        top: 0;
        left: 0;
        background: rgba(0, 0, 0, 0.8);
        z-index: 9999;
        overflow-y: hidden;
        overscroll-behavior: contain;
    }

    .modal-content img {
        max-width: 70vw;
        max-height: 70vh;
        width: auto;
        height: auto;
        object-fit: contain;
        display: block;
        margin: 0 auto;
    }

    .close-btn {
        top: 10px;
        right: 15px;
        font-size: 24px;
        cursor: pointer;
    }

    .sticky-controls {
        top: 60px;
    }
}

@media (min-width: 768px) {
    .img-container {
        height: 80px;
        width: 80px;
    }

    .more-image {
        height: 80px;
        width: 80px;
        font-size: 16px;
        object-fit: cover;
        border: 1px solid #ccc;
    }

    .csr-header {
        font-size: 20px;
    }
}

@media (min-width: 992px) {
    .grid-header {
        display: flex;
        flex-wrap: wrap;
    }

    .grid-header>div {
        width: 50% !important;
        box-sizing: border-box;
    }

    .img-placeholder {
        height: 150px;
    }

    .modal-content img {
        max-height: 80vh;
    }
}

@media (min-width: 1200px) {
    .cms-container {
        margin-left: 310px;
        width: calc(100% - 310px);
        margin-top: 82px;
    }

    .sticky-controls {
        top: 82px;
    }
}
</style>